import { styled,Button,
     Typography } from "@mui/material";

export const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 911,
    height: 382,
    borderRadius: "12px",
    bgcolor: "var(--Card-Background, #FAFAFA)",
    boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
};
export const successStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 911,
    height: 301,
    borderRadius: "12px",
    bgcolor: "var(--Card-Background, #FAFAFA)",
    boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
};

export const DeleteCancelButton = styled(Button)(() => ({
    position: "absolute",
    top: 288,
    bottom: 44,
    left: 91,
    right: 520,
    width: 300,
    height: 50,
    background:
        "var(--Medium-Green, var(--color-brand-Green-Medium, #7CBA25))",
    borderRadius: "12px",
    "&:hover": {
        background: "var(--color-brand-Green-Medium, #7CBA25)",
    },
}));

export const DeleteConfirmButton = styled(Button)(() => ({
    position: "absolute",
    top: 288,
    bottom: 44,
    left: 520,
    right: 91,
    width: "300px",
    height: "50px",
    background:
        "var(--Warning-Red, #E52B24)",
    borderRadius: "12px",
    "&:hover": {
        background: "var(--Warning-Red, #E52B24)",
    },
}));

export const ButtonNames = styled(Typography)(() => ({
    top: 5, 
    bottom: 6, 
    left: 132, 
    right: 125, 
    color: "var(--Whiteish-Background, #FDFBF9)", 
    fontFamily: "Calibri", 
    fontSize: 32, 
    fontWeight: 300, 
    letterSpacing: 0.48, 
    textAlign: "center", 
    lineHeight: "normal",
    fontStyle: "normal",
}));

export const CloseImg = styled('img')(() => ({
    position: "absolute",
    top: 14,
    right: 12,
    width: 24,
    height: 24,
    fill: "var(--Dark-Gray, #666461)",
}));

export const Title = styled('h1')(() => ({
    position: "absolute",
    top: 35,
    bottom: 332,
    right: 110,
    left: 130,
    height: 39,
    width: 651,
    color: "var(--Black, #333230)",
    textAlign: "center",
    fontFamily: "Calibri",
    fontSize: 24,
    fontStyle: "normal",
    fontWeight: "300",
    lineHeight: "normal",
}));

export const PipelineId = styled('span')(() => ({
    color: "#00A9CE", 
    fontFamily: "Calibri", 
    fontSize: 25.55, 
    fontWeight: 300, 
    lineHeight: "normal", 
    fontStyle: "normal"
}));

export const CautionImg = styled('img')(() => ({
    position: "absolute",
    alignItems: "center",
    top: 102,
    right: 380,
    left: 381,
    bottom: 146,
    width: 150,
    height: 134,
    marginBottom: 52,
}));

export const CheckmarkImg = styled('img')(() => ({
    position: "absolute",
    top: 107,
    bottom: 44,
    right: 380,
    left: 381,
    width: "150px",
    height: "150px",
}));

export const ErrorDiv = styled('div')(() => ({
    color:"var(--Warning-Red, #E52B24)",
    position: "absolute",
    top: 10,
    bottom: 325,
    right: 30,
    left: 30,
    height: 39,
    width: 850,
    fontFamily: "Calibri", 
    fontSize: 18, 
    fontWeight: 400, 
    textAlign: "center", 
    lineHeight: "normal",
    fontStyle: "normal",
}));